import { useRef, useState } from "react";

interface VideoPlayerProps {
  src: string;
  poster?: string;
  className?: string;
}

export function VideoPlayer({ src, poster, className = "w-full rounded-lg border shadow-xs" }: VideoPlayerProps) {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [buffering, setBuffering] = useState(false);

  return (
    <div className="relative">
      {buffering && (
        <div className="absolute inset-0 flex items-center justify-center bg-black/30 rounded-lg z-10 pointer-events-none">
          <div className="w-8 h-8 border-4 border-white border-t-transparent rounded-full animate-spin" />
        </div>
      )}
      <video
        ref={videoRef}
        controls
        preload="metadata"
        className={className}
        poster={poster}
        src={src}
        style={{ maxHeight: '70vh', width: '100%', objectFit: 'contain' }}
        onWaiting={() => setBuffering(true)}
        onPlaying={() => setBuffering(false)}
        onCanPlay={() => setBuffering(false)}
      >
        Your browser does not support video.
      </video>
    </div>
  );
}
